import { AddIncentiveOfferPageContextType } from '../types/AddIncentiveOfferPageContextType';
import { defaultSellerParticipationLimits } from './defaultSellerParticipationLimits';

export const addIncentiveOfferPageInitValue: AddIncentiveOfferPageContextType = {
  data: {
    incentiveOfferType: null,
    actionType: '',
    beneficiaryOptions: [],
    selectedBeneficiaryOption: null,
    beneficiaryCurrentUnitsCount: 0,
    beneficiaryCif: '',
    beneficiaryCifGroupIds: [],
    plansBreakdown: [],
    reservedUnits: 0,
    sharesToTransfer: 0,
    maxSharesToTransfer: 0,
    isSellAllMyShares: false,
    isPartialAmountEnabled: false,
    minUnitsPerAcceptance: 1,
    additionalNotes: '',
    price: 0,
    isPricePerShare: true,
    pricePerShare: 0,
    totalOfferPrice: 0,
    startDate: '',
    endDate: '',
    calculationDate: '',
    societyId: '',
    societyName: '',
    isBeneficiaryView: false,
    isAdmin: false,
    isReadOnly: false,
    isLoading: true,
    isLoadingBeneficiaryContext: false,
    isMarketClosed: false,
    sellerParticipationLimits: defaultSellerParticipationLimits,
  },
  actions: {
    handleChangePartner: () => {},
    handleSearchBeneficiaryByTerm: async () => [],
    handleChangeSharesToTransfer: () => {},
    handleChangeIsSellAllMyShares: () => {},
    handleChangeIsPartialAmountEnabled: () => {},
    handleChangeMinSharesPerAcceptance: () => {},
    handleChangeAdditionalNotes: () => {},
    handleChangePrice: () => {},
    handleChangeIsPricePerShare: () => {},
    handleChangeStartDate: () => {},
    handleChangeEndDate: () => {},
    handleChangeCalculationDate: () => {},
    handleSetDatePreset: () => {},
    handleChangeAllowSellAll: () => {},
    handleChangeSellerLimit: () => {},
    handleReviewIncentiveOffer: () => {},
  },
};
